import { EditSusunanKeluargaPayload } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allSusunanKeluargaKey } from "../../queries/SusunanKeluarga/useFetchAllSusunanKeluarga";
import { allSusunanKeluargaOTKey } from "../../queries/SusunanKeluarga/useFetchAllSusunanKeluargaOT";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function removeSusunanKeluarga(SUSUNAN_KELUARGA_ID: number) {
  const res = await ApiClient.delete(
    `/RemoveKeluarga?SUSUNAN_KELUARGA_ID=${SUSUNAN_KELUARGA_ID}`
  );
  return res.data[0];
}

export const useRemoveSusunanKeluarga = mutationWrapper(removeSusunanKeluarga, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allSusunanKeluargaKey);
    getQueryClient().invalidateQueries(allSusunanKeluargaOTKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
